function AssessmentPlan() {
  const features = [
    "Holistic assessment of scholastic and co-scholastic growth",
    "Focus on thinking skills instead of rote learning",
    "Interactive teaching and continuous evaluation",
    "Regular unit tests and feedback system",
    "Identification and correction of learning gaps",
    "Pen-paper and non pen-paper assessments",
    "Life skills, attitudes, values, sports and co-curricular activities",
    "Self-evaluation opportunities for students",
  ];

  const assessments = [
    {
      title: "FA-1",
      desc: "Pen-paper based formative assessment conducted during Term 1.",
    },
    {
      title: "FA-2",
      desc: "Interdisciplinary group project under teacher supervision.",
    },
    {
      title: "FA-3",
      desc: "Pen-paper based formative assessment conducted during Term 2.",
    },
    {
      title: "FA-4",
      desc: "Project-based interdisciplinary assessment activity.",
    },
    {
      title: "SA-1",
      desc: "Summative Assessment conducted at the end of Term 1.",
    },
    {
      title: "SA-2",
      desc: "Summative Assessment conducted at the end of Term 2.",
    },
  ];

  return (
    <section className="py-16 px-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-14">
          <h1 className="text-5xl font-bold text-blue-900 mb-4">
            Assessment Plan
          </h1>

          <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Capitol Public School follows the CBSE Continuous and Comprehensive
            Evaluation (CCE) system to ensure holistic growth, conceptual
            understanding, and overall personality development of students.
          </p>
        </div>

        {/* Intro Section */}
        <div className="bg-white rounded-3xl shadow-lg p-8 mb-10 border-l-4 border-yellow-400">

          <h2 className="text-3xl font-bold text-blue-900 mb-5">
            CCE – Welcome Changes
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            Continuous and Comprehensive Evaluation (CCE) has introduced a
            positive transformation in student assessment by moving away from
            rote learning and memorization towards skill-based and conceptual
            learning.
          </p>

          <p className="text-gray-700 leading-relaxed">
            The system evaluates both scholastic and co-scholastic areas,
            including life skills, attitudes, values, sports, games, performing
            arts, yoga, work experience, environmental awareness, and other
            co-curricular activities.
          </p>

        </div>

        {/* Features */}
        <div className="mb-12">

          <h2 className="text-3xl font-bold text-yellow-500 mb-8 text-center">
            Key Features of CCE
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">

            {features.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow hover:shadow-xl transition"
              >
                <p className="text-gray-700 font-medium">
                  ✔ {item}
                </p>
              </div>
            ))}

          </div>

        </div>

        {/* Assessment Structure */}
        <div className="bg-white rounded-3xl shadow-lg p-8">

          <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
            Assessment Structure
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            {assessments.map((item, index) => (
              <div
                key={index}
                className="bg-gray-100 rounded-2xl p-6 hover:shadow-md transition"
              >
                <h3 className="text-2xl font-bold text-yellow-500 mb-3">
                  {item.title}
                </h3>

                <p className="text-gray-700 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
}

export default AssessmentPlan;